require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/fn/regexp/escape.js
// module id = 584
// module chunks = 0